

import { auth } from './auth'

export const rootReducer = {
  auth
}
